import config from "@/config";
import errors from "@/errors";
import Vue from "vue";

export default {
  loading: {
    livetv: false,
    // gamingsoft: false,
    live22: false,
    gameplay: false,
    sagaming: false,
    ctgaming: false,
    pggaming: false,
    vivogaming: false,
    evolution: false,
    minigame: false,
    yeebet: false,
    lcppg: false,
    pgslot: false,
    pragmatic: false,
    w4d: false,
    prg: false,
    esp: false,
    joker: false,
    spp: false,
    jili: false,
    uusl: false,
    next: false,
    dbhash: false,
    wow: false,
    ai: false,
    wf: false,
    epw: false,
    awc: false
  },
  prg(args) {
    const url = config.prgUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "prg"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("min" in args) || !args.min) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("max" in args) || !args.max) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("bet_type" in args) || !args.bet_type) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("comm_type" in args) || !args.comm_type) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.prg = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.prg = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.value;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.prg = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchLiveTV(args) {
    const url = config.whiteLabel == "1" ? config.apiTvUrl() : config.liveTvUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchLiveTV"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("channel" in args) || !args.channel) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("match" in args) || !args.match) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sports" in args) || !args.sports) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
      }

      if (canRequest == true) {
        this.loading.livetv = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.livetv = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.livetv = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchL22(args) {
    const url = config.launchL22Url();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchL22"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("player_id" in args) || !args.player_id) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("password" in args) || !args.password) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.live22 = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.live22 = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.live22 = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  // launchGS(args) {
  //   const url = config.launchGSUrl();
  //   const feedback = {
  //     success: false,
  //     status: errors.request.failed,
  //     data: null,
  //     source: "launchGS"
  //   };
  //   return new Promise((resolve, reject) => {
  //     var canRequest = true;

  //     if (!args) {
  //       feedback.status = errors.request.incompleted;
  //       reject(feedback);
  //       canRequest = false;
  //     }

  //     if (!("player_id" in args)) {
  //       feedback.status = errors.request.incompleted;
  //       reject(feedback);
  //       canRequest = false;
  //     }
  //     if (!("password" in args)) {
  //       feedback.status = errors.request.incompleted;
  //       reject(feedback);
  //       canRequest = false;
  //     }
  //     if (!args.player_id) {
  //       feedback.status = errors.request.failed;
  //       reject(feedback);
  //       canRequest = false;
  //     }
  //     if (!args.password) {
  //       feedback.status = errors.request.failed;
  //       reject(feedback);
  //       canRequest = false;
  //     }

  //     if (canRequest == true) {
  //       this.loading.gamingsoft = true;
  //       Vue.http.post(url, args).then(
  //         res => {
  //           this.loading.gamingsoft = false;
  //           if (res.data) {
  //             // check status code
  //             if (typeof res.data.status == "string") {
  //               feedback.success = res.data.status == "1";
  //             } else {
  //               feedback.success = res.data.status == 1;
  //             }

  //             feedback.status = res.data.statusdesc;

  //             if (feedback.success == true) {
  //               // Successfully response
  //               try {
  //                 feedback.data = res.data.url;
  //                 resolve(feedback);
  //               } catch (error) {
  //                 // Failed to login
  //                 feedback.success = false;
  //                 feedback.status = errors.login.failed;
  //                 reject(feedback);
  //               }
  //             } else {
  //               reject(feedback);
  //             }
  //           } else {
  //             // Response is empty...
  //             reject(feedback);
  //           }
  //         },
  //         err => {
  //           this.loading.gamingsoft = false;

  //           feedback.status = errors.request.failed;
  //           feedback.error = err;
  //           reject(feedback);
  //         }
  //       );
  //     } else {
  //       reject(feedback);
  //     }
  //   });
  // },
  launchGP(args) {
    const url = config.launchGPUrl();
    // console.log(url);
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchGP"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("player_id" in args) || !args.player_id) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("password" in args) || !args.password) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.gamingsoft = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.gamingsoft = false;
            if (res.data) {
              // check status code
              if (typeof res.data.status == "string") {
                feedback.success = res.data.status == "1";
              } else {
                feedback.success = res.data.status == 1;
              }

              feedback.status = res.data.statusdesc;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.gamingsoft = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchSA(args) {
    const url = config.launchSAUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchSA"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.sagaming = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.sagaming = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.sagaming = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchCT(args) {
    const url = config.launchCTUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchCT"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.ctgaming = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.ctgaming = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.ctgaming = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchVivo(args) {
    const url = config.launchVivoUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchVivo"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.vivogaming = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.vivogaming = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.vivogaming = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchPG(args) {
    const url = config.launchPGUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchPG"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.pggaming = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.pggaming = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.pggaming = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchEV(args) {
    const url = config.launchEVUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchEV"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.evolution = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.evolution = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.evolution = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchYB(args) {
    const url = config.launchYBUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchYB"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.yeebet = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.yeebet = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.yeebet = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchLCPPG(args) {
    const url = config.launchLCPPGUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchLCPPG"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.lcppg = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.lcppg = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.lcppg = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchW4D(args) {
    const url = config.launchW4DUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchW4D"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.w4d = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.w4d = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.w4d = false;

            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchPGS(args) {
    const url = config.launchPGSUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchPGS"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.pgslot = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.pgslot = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.pgslot = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchPPGGameList(args) {
    const url = config.launchPPGGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchPPGGameList"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.pragmatic = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.pragmatic = false;
            if (res.data) {
              // check status code
              if (typeof res.data == "object") {
                feedback.success = true;
                feedback.status = errors.request.succeed;
              }
              // feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.pragmatic = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchPPG(args) {
    const url = config.launchPPGUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchPPG"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.pragmatic = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.pragmatic = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.pragmatic = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchESP(args) {
    const url = config.launchESPUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchESP"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.esp = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.esp = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.esp = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchJKRGameList(args) {
    const url = config.launchJKRGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchJKRGameList"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.joker = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.joker = false;
            if (res.data) {
              // check status code
              if (typeof res.data == "object") {
                feedback.success = true;
                feedback.status = errors.request.succeed;
              }
              // feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.joker = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchJKR(args) {
    const url = config.launchJKRUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchJKR"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.joker = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.joker = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.joker = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchJILIGameList(args) {
    const url = config.launchJILIGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchJILIGameList"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.jili = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.jili = false;
            if (res.data) {
              // check status code
              if (typeof res.data == "object") {
                feedback.success = true;
                feedback.status = errors.request.succeed;
              }
              // feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.jili = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchJILI(args) {
    const url = config.launchJILIUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchJILI"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.jili = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.jili = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.jili = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchUUSLGameList(args) {
    const url = config.launchUUSLGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchUUSLGameList"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.uusl = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.uusl = false;
            if (res.data) {
              // check status code
              if (typeof res.data == "object") {
                feedback.success = true;
                feedback.status = errors.request.succeed;
              }
              // feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.uusl = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchUUSL(args) {
    const url = config.launchUUSLUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchUUSL"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.uusl = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.uusl = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.uusl = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchNEXT(args) {
    const url = config.launchNEXTUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchNEXT"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.next = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.next = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.next = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchMiniGame(args) {
    const url = config.launchMagUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchMiniGame"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.minigame = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.minigame = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.minigame = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchSPP(args) {
    const url = config.launchSPPUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchSPP"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.spp = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.spp = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.spp = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchDbHash(args) {
    const url = config.launchDbHashUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchDbHash"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.dbhash = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.dbhash = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.dbhash = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchDbPoker(args) {
    const url = config.launchDbPokerUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchDbPoker"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.dbhash = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.dbhash = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.dbhash = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchWowGaming(args) {
    const url = config.launchWowGamingUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchWowGaming"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.wow = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.wow = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.wow = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchAiCasino(args) {
    const url = config.launchAiCasinoUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchAiCasino"
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.ai = true;
        Vue.http.post(url, args).then(
          res => {
            this.loading.ai = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          err => {
            this.loading.ai = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchLive22(args) {
    const url = config.launchLive22Url();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchLive22",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.live22 = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.live22 = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.live22 = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  getLive22GameList(args) {
    const url = config.getLive22GameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getLive22GameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.live22 = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.live22 = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.live22 = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchWf(args) {
    const url = config.launchWfUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchWf",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.wf = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.wf = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.wf = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchWfGameList(args) {
    const url = config.launchWfGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchWfGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.wf = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.wf = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.wf = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchEPW(args) {
    const url = config.launchEPWUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchEPW",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.epw = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.epw = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.epw = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchEPWGameList(args) {
    const url = config.launchEPWGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchEPWGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.epw = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.epw = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.epw = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchAwc(args) {
    const url = config.launchAwcUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchAwc",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.awc = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.awc = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.awc = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  getAwcGameList(args) {
    const url = config.getAwcGameListUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "getAwcGameList",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      // if (!("username" in args) || !args.username) {
      //   feedback.status = errors.request.incompleted;
      //   reject(feedback);
      //   canRequest = false;
      // }
      // if (!("sessionid" in args) || !args.sessionid) {
      //   feedback.status = errors.request.incompleted;
      //   reject(feedback);
      //   canRequest = false;
      // }

      if (canRequest == true) {
        this.loading.awc = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.awc = false;
            if (res.body) {
              feedback.success = true;
              feedback.status = "ok";
              feedback.data = res.body;
              resolve(feedback);
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.awc = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
  launchAio(args) {
    const url = config.launchAioUrl();
    const feedback = {
      success: false,
      status: errors.request.failed,
      data: null,
      source: "launchAio",
    };
    return new Promise((resolve, reject) => {
      var canRequest = true;

      if (!args) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (!("username" in args) || !args.username) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }
      if (!("sessionid" in args) || !args.sessionid) {
        feedback.status = errors.request.incompleted;
        reject(feedback);
        canRequest = false;
      }

      if (canRequest == true) {
        this.loading.awc = true;
        Vue.http.post(url, args).then(
          (res) => {
            this.loading.awc = false;
            if (res.data) {
              // check status code
              if (typeof res.data.errorId == "string") {
                feedback.success = res.data.errorId == "0";
              } else {
                feedback.success = res.data.errorId == 0;
              }

              feedback.status = res.data.message;

              if (feedback.success == true) {
                // Successfully response
                try {
                  feedback.data = res.data.client_url;
                  resolve(feedback);
                } catch (error) {
                  // Failed to login
                  feedback.success = false;
                  feedback.status = errors.login.failed;
                  reject(feedback);
                }
              } else {
                reject(feedback);
              }
            } else {
              // Response is empty...
              reject(feedback);
            }
          },
          (err) => {
            this.loading.awc = false;
            feedback.status = errors.request.failed;
            feedback.error = err;
            reject(feedback);
          }
        );
      } else {
        reject(feedback);
      }
    });
  },
};
